'use client';
import { memo } from 'react';
import type { LinkObj } from '@repo/ui/src/types/link';
import type { MediaType } from '@repo/ui/src/types/image';
import type { MetaProps } from '@repo/ui/src/types/meta';
import type { YoutubeLinkProps } from '@repo/ui/src/types/youtubeLink';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import StoriesGridItemContent from './_StoriesGridItemContent';
import { StoryItemContainer } from './styles';

export interface StoryItem {
  title?: string;
  description?: string;
  image?: MediaType;
  actionText?: string;
  youtubeLink?: YoutubeLinkProps;
  index?: number;
  _meta?: MetaProps;
}

interface StoriesGridItemProps {
  item: StoryItem;
}

const StoriesGridItem = ({ item }: StoriesGridItemProps) => {
  const { push } = useModal(ModalID.video);
  const { youtubeLink, index, _meta } = item || {};
  const linkObj: LinkObj | null = _meta?.deliveryKey
    ? buildLinkObj({ link: _meta?.deliveryKey })
    : null;

  const content = <StoriesGridItemContent {...item} linkObj={linkObj} />;

  if (linkObj) {
     
    const anchorProps: any = { component: 'a', rel: getRel(linkObj), href: linkObj?.href };
    return (
      <StoryItemContainer {...anchorProps}>
        {content}
      </StoryItemContainer>
    );
  }
  if (youtubeLink) {
    return (
      <StoryItemContainer
        role="button"
        tabIndex={index}
        onClick={() => push({ youtubeLink, playlistItems: youtubeLink?.associatedPlaylist?.body })}
        onKeyDown={() =>
          push({ youtubeLink, playlistItems: youtubeLink?.associatedPlaylist?.body })
        }
      >
        {content}
      </StoryItemContainer>
    );
  }
  return <StoryItemContainer>{content}</StoryItemContainer>;
};

export default memo(StoriesGridItem);
